
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const Submenus = (props) => {
    const handleEventClick = (e) => {
        e.stopPropagation();
        //console.log("Overspeed ",props);
        props.context.componentParent.onShowMenus(0);
    };
    
    return (
        <div>
            <button onClick={handleEventClick} className="custom-btn f22 label label-success" 
             ><i className="icofont icofont-eye-alt"></i> &nbsp;</button>
            
        </div>
    );
};

export default Submenus;
